import React from 'react';
import { Brain, Sparkles, TrendingUp, Headphones } from 'lucide-react';

const iconMap = { Brain, Sparkles, TrendingUp, Headphones };

import { whyChooseUs } from '../mock';

const WhyChooseUs = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="section-label mb-6">Why Choose Us</div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white tracking-tight leading-tight">
            Driven by Results <br /> Powered by Expertise
          </h2>
          <p className="text-slate-400 max-w-md">
            We combine strategy and engineering to deliver scalable cloud solutions.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-2 gap-5">
          {whyChooseUs.map((item) => {
            const Icon = iconMap[item.icon];
            return (
              <div key={item.title} className="card-dark rounded-3xl p-8 group hover:border-amber-400/30 transition-colors">
                <div className="h-14 w-14 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center mb-6 group-hover:bg-amber-500/15">
                  <Icon className="text-amber-400" size={26} strokeWidth={1.5} />
                </div>
                <h3 className="text-white text-xl font-semibold mb-3">{item.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
